import React from "react";
import { UIChromosome } from "../../euglena/chromosome/ui.chr";

export const useContext = () => {
    const context = (window as any).euglena.ui.context as any;
    return React.useContext<UIChromosome>(context);
} 